import { jwtDecode } from "jwt-decode";

export const enumerateReadOnly = <K extends string>(
  ...keys: K[]
): Readonly<{ [T in K]: T }> => {
  const init = {} as { [T in K]: T };
  const enumObj = keys.reduce((a, v) => ({ ...a, [v]: v }), init);
  return enumObj as Readonly<typeof enumObj>;
};

export interface DecodedData {
  exp: number;
  [key: string]: any;
}

export const getTokenRefreshTime = (token: string): number => {
  const fiveMinutes = 300000;
  const decoded: DecodedData = jwtDecode(token);
  const expiration = new Date(decoded.exp * 1000);
  let tokenTimeLeft = expiration.getTime() - new Date().getTime() - fiveMinutes;
  if (tokenTimeLeft <= 0) {
    return 1;
  }
  return tokenTimeLeft;
};

export const capitalizeFirstLetter = (input: any) => {
  const string = String(input);
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

export const blobToBase64 = (blob: Blob | null): Promise<string | null> => {
  if (!blob) {
    return Promise.resolve(null);
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
};

export const base64ToBlob = (base64: string | null): Blob | null => {
  if (!base64) {
    return null;
  }
  const byteString = atob(base64.split(",")[1]);
  const mimeString = base64.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

export const formatNumber = (value: number, returnInt: boolean = false) => {
  if (returnInt) return Math.floor(value);
  return Number.isInteger(value) ? value : value.toFixed(2);
};

export const getCurrencySymbol = (currency: string) => {
  switch (currency) {
    case "USD":
      return "$";
    case "EUR":
      return "€";
    case "NIS":
      return "₪";
    default:
      return currency;
  }
};
